module.exports = __webpack_public_path__ + "static/szwj-logo-adc93f5e25d1e833adc8997814f805fa.png";